import { Page } from 'layouts/Page';
import { FC } from 'react';
import { PpwrLayout } from 'components/EprPpwr/PpwrLayout';
import { PpwrCountryExclusions } from 'components/EprPpwr/PpwrCountryExclusions';

export const PpwrCountryExclusionPage: FC = () => {
	return (
		<Page title="Country exclusion – EPR/PPWR – EAS Dashboard">
			<PpwrLayout>
				<PpwrCountryExclusions />
			</PpwrLayout>
		</Page>
	);
};
